export const LookupValueMapping = {
  Activities: "Activities",
};
